export var removeRetailerTokenFromUrl = function() {
    var url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return url.replace(/\/retailer\/r_[0-9, a-z]+/g, "");
};
